import {styled} from "@mui/material/styles";
import {TableCell, tableCellClasses} from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: 'white',
        paddingTop: '8px',
        paddingBottom: '8px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '1.6rem',
        fontWeight: 600,
        padding: '4px 16px 4px 16px',
        verticalAlign: 'middle !important',
    },
}));

export default StyledTableCell;